import React from 'react';
import Icon from '../../../components/AppIcon';

const SeasonalTrends = ({ data }) => {
  const getSeasonIcon = (season) => {
    switch (season) {
      case 'Dry Season':
        return 'Sun';
      case 'Wet Season':
        return 'CloudRain';
      case 'Peak Wildlife':
        return 'Bird';
      case 'Nesting Period':
        return 'Egg';
      default:
        return 'Calendar';
    }
  };

  const getSeasonColor = (season) => {
    switch (season) {
      case 'Dry Season':
        return 'bg-accent/20 text-accent';
      case 'Wet Season':
        return 'bg-info/20 text-info';
      case 'Peak Wildlife':
        return 'bg-secondary/20 text-secondary';
      case 'Nesting Period':
        return 'bg-warning/20 text-warning';
      default:
        return 'bg-primary/20 text-primary';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Seasonal Trends Analysis</h3>
          <p className="text-sm text-muted-foreground">Wildlife patterns and optimal visiting periods</p>
        </div>
        <Icon name="Calendar" size={24} className="text-primary" />
      </div>
      <div className="space-y-4">
        {data?.map((season) => (
          <div key={season?.id} className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className={`p-3 rounded-lg ${getSeasonColor(season?.name)}`}>
                  <Icon name={getSeasonIcon(season?.name)} size={24} />
                </div>
                <div>
                  <h4 className="text-base font-semibold text-foreground">{season?.name}</h4>
                  <p className="text-sm text-muted-foreground">{season?.period}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-foreground">{season?.avgVisitors?.toLocaleString()}</p>
                <p className="text-xs text-muted-foreground">avg visitors/day</p>
              </div>
            </div>

            <div className="space-y-2 mb-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Visitor Satisfaction</span>
                <span className="font-medium text-foreground">{season?.satisfaction}%</span>
              </div>
              <div className="relative h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="absolute left-0 top-0 h-full bg-success transition-all duration-500"
                  style={{ width: `${season?.satisfaction}%` }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mb-3">
              <div className="flex items-center gap-2">
                <Icon name="Thermometer" size={16} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">Weather: {season?.weather}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Eye" size={16} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">Visibility: {season?.visibility}</span>
              </div>
            </div>

            <div className="pt-3 border-t border-border">
              <p className="text-xs text-muted-foreground mb-2">Key Wildlife Activities:</p>
              <div className="flex flex-wrap gap-2">
                {season?.activities?.map((activity, index) => (
                  <span key={index} className="text-xs px-2 py-1 bg-primary/10 text-primary rounded">
                    {activity}
                  </span>
                ))}
              </div>
            </div>

            {season?.recommendation && (
              <div className="mt-3 flex items-start gap-2 bg-accent/10 rounded-lg p-3">
                <Icon name="AlertCircle" size={16} className="text-accent mt-0.5" />
                <p className="text-xs text-foreground">{season?.recommendation}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SeasonalTrends;